import {useActions, useGetters, useMutators, useState} from './_map';
export default {
    namespaced: true,
    state: {
        ...useState(),
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
    },
}
